import Mention from '@tiptap/extension-mention';

// Mappa emoji per i diversi tipi di tag (fallback quando non c'è icona)
const TAG_EMOJI_MAP: Record<string, string> = {
  video: '🎥',
  audio: '🎵',
  document: '📄',
  image: '🖼️',
  question: '❓',
};

const getTagEmoji = (type: string): string => {
  return TAG_EMOJI_MAP[type.toLowerCase()] || '';
};

export const CustomMention = Mention.extend({
  addAttributes() {
    return {
      type: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-tag-type'),
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.type) {
            return {};
          }
          return {
            'data-tag-type': attributes.type,
            'data-tag-id': attributes.id,
            'data-tag-label': attributes.label,
            'data-tag-icon': attributes.icon,
            'data-tag-description': attributes.description,
          };
        },
      },
      id: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-tag-id'),
      },
      label: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-tag-label'),
      },
      icon: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-tag-icon'),
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.icon) {
            return {};
          }
          return {
            'data-tag-icon': attributes.icon,
          };
        },
      },
      description: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-tag-description'),
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.description) {
            return {};
          }
          return {
            'data-tag-description': attributes.description,
          };
        },
      },
    };
  },

  renderHTML({
    HTMLAttributes,
    node,
  }: {
    HTMLAttributes: Record<string, any>;
    node: { attrs: Record<string, any> };
  }) {
    const type = node.attrs.type || HTMLAttributes['data-tag-type'];
    const label = node.attrs.label || HTMLAttributes['data-tag-label'] || '';
    const id = node.attrs.id || HTMLAttributes['data-tag-id'];
    const icon = node.attrs.icon || HTMLAttributes['data-tag-icon'];
    const description =
      node.attrs.description || HTMLAttributes['data-tag-description'];
    const emoji = type ? getTagEmoji(type) : '';

    // Se c'è un'icona specifica, usala invece dell'emoji
    if (icon) {
      return [
        'span',
        {
          'data-tag-type': type,
          'data-tag-id': id,
          'data-tag-label': label,
          'data-tag-icon': icon,
          'data-tag-description': description || '',
          title: description || '', // Tooltip con la description
          class: 'mention-tag mention-tag-with-icon',
          style: ``,
        },
        label,
      ];
    }

    // Fallback all'emoji se non c'è icona
    if (emoji) {
      return [
        'span',
        {
          'data-tag-type': type,
          'data-tag-id': id,
          'data-tag-label': label,
          'data-tag-description': description || '',
          title: description || '', // Tooltip con la description
          class: 'mention-tag',
          style: ``,
        },
        `${emoji} ${label}`,
      ];
    }

    return [
      'span',
      {
        'data-tag-type': type,
        'data-tag-id': id,
        'data-tag-label': label,
        'data-tag-description': description || '',
        class: 'mention-tag',
      },
      label || 'Mention',
    ];
  },
}).configure({
  HTMLAttributes: {
    class: 'mention-tag',
  },
});
